'use client'

import { isEmpty } from 'lodash-es'
import { useFormContext, useWatch } from 'react-hook-form'

import { Form } from '@/shared/ui'

type Props = {
  placeholder?: string
  readOnly?: boolean
  disabled?: boolean
  autoComplete?: boolean
}

export const PasswordField = ({
  placeholder,
  readOnly = false,
  disabled = false,
  autoComplete = false,
}: Props) => {
  const { control, clearErrors, formState } = useFormContext()

  const passwordConfirm = useWatch({
    control,
    name: 'passwordConfirm',
  })

  const handleChange = () => {
    const isPasswordMatchError =
      !!formState.errors.passwordConfirm && !isEmpty(passwordConfirm)

    if (isPasswordMatchError) {
      clearErrors('passwordConfirm')
    }
  }

  return (
    <Form.Field
      name="password"
      readOnly={readOnly}
      disabled={disabled}
      onChange={handleChange}
    >
      <Form.Label className="font-medium text-black">비밀번호</Form.Label>
      <Form.PasswordField
        placeholder={placeholder || '영문, 숫자 조합 6자-15자를 입력해 주세요'}
        fullWidth
        readOnly={readOnly}
        {...(!autoComplete && { autoComplete: 'new-password' })}
      />
      <Form.Message />
    </Form.Field>
  )
}
